import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {CoordinationsAlerts} from "../../services/coordinations-alerts.service";

export class coordinationsListCtrl implements IController {

  coordinations: any;

  private totalsLoading: boolean;
  private loading: boolean;
  private queryString: string;

  /* @ngInject */
  constructor(private $log, private coordinationsAlerts: CoordinationsAlerts, private coordinationRequests) {
  }

  $onInit() {
    this.totalsLoading = false;
  };

  // ******************************
  //        External methods
  // ******************************

  declineCoordination(coordinationToDecline) {
    this.loading = true;

    this.coordinationRequests.declineCoordination(coordinationToDecline.id)
      .then((updatedCoordination) => {
        this.loading = false;
        this.coordinationsAlerts.declineSuccess();

        const coordinationIndex = _.findIndex(this.coordinations, (coordination: any) => {
          return _.isEqual(coordination.id, updatedCoordination.id);
        });

        if (coordinationIndex) {
          this.coordinations[coordinationIndex] = updatedCoordination;
        }
      })
      .catch((error) => {
        this.coordinationsAlerts.declineError();
        this.$log.error('Failed to decline coordination, ' +
          'coordinationsList@declineCoordination', error)
      })
  }

  submitQuery(query) {
    this.queryString = query
  }

}

angular
  .module('bringoz.admin.coordinations')
  .component('coordinationsList', {
    bindings: {
      coordinations: '<'
    },
    template: require('./coordinations-list.tmpl.html').default,
    controller: coordinationsListCtrl
  });
